export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatFullName = (firstName: string, lastName: string): string => {
  return `${
    firstName && capitalizeFirstLetter(firstName.toLocaleLowerCase())
  } ${lastName && capitalizeFirstLetter(lastName?.toLocaleLowerCase())}`;
};
